import causaContadoresList from './list';
import causaContadoresEdit from './edit';
import causaContadoresCreate from './create'

export default {
    list : causaContadoresList,
    create : causaContadoresCreate,
    edit : causaContadoresEdit
}